<template>
  <div class="chartComp">
    <div class="toolbar">
      <div></div>
      <select
        v-show="questions.length"
        class="select_grey"
        v-on:change="set($event)"
      >
        <option v-for="(question, index) in questions" :key="index" :value="question.id">{{ question.name }}</option>
      </select>
      <button v-if="urlReport" :class="['btn_orange']" @click="downladReport">Скачать Excel</button>
      <button v-if="!urlReport" :class="['btn_white']" @click="getReport">Сформировать Excel</button>
    </div>
    <div
      v-if="!questionsStat.labels.length"
      class="div_nodata">
      <label class="label_nodata">Нет данных</label>
    </div>
    <pie-chart
      v-if="questionsStat.labels.length"
      :labels="questionsStat.labels"
      :datasets="questionsStat.datasets"
    />
  </div>
</template>

<script>

export default {
  name: 'chartComp',
  props: {
  },
  data: function () {
    return {
      moduleName: 'stat',
      activeBtn: 'day'
    }
  },
  beforeCreate () {
    this.$store.dispatch(`stat/getQuestions`, {})
  },
  created: function () { },
  components: { },
  watch: { },
  computed: {
    questions: function () { return this.$store.getters[`${this.moduleName}/getQuestions`] },
    questionsStat: function () {
      let stat = this.$store.getters[`${this.moduleName}/getQuestionsStat`]
      let backgroundColor = []
      stat.data.forEach(element => {
        backgroundColor.push(this.$helpers.color.random())
      })
      for (let i = 0; i < stat.labels.length; i++) {
        stat.labels[i] += ` ( ${stat.data[i]} )`
      };
      return {
        labels: stat.labels,
        datasets: [{ backgroundColor, data: stat.data }]
      }
    },
    urlReport: function () { return this.$store.getters[`${this.moduleName}/getUrlQuestions`] }
  },
  methods: {
    set (e) {
      this.$store.dispatch(`${this.moduleName}/getQuestionsStat`, { params: { questionId: e.target.value } })
    },
    getReport () {
      this.$store.dispatch(`${this.moduleName}/getQuestionsReport`, {})
    },
    downladReport () {
      let url = `${this.$http.server_api_url}/${this.urlReport}`
      window.open(url, '_blank')
      this.$store.commit(`${this.moduleName}/setUrlQuestions`, '')
    }
  }
}
</script>

<style scoped lang="scss">

.chartComp {
  margin: 32px;
}

.toolbar {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 180px 180px 1fr;
  grid-column-gap: 10px;
  margin-bottom: 15px;
  grid-row-gap: 15px;
}
.div_btns {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: auto auto auto auto;
  grid-column-gap: 10px;
}

.btn_orange {
  width: 100%;
  height: 36px;
  object-fit: contain;
  border-radius: 9px;
  background-color: #ff8200;
  object-fit: contain;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  color: #ffffff;
};
.btn_white {
  width: 100%;
  height: 36px;
  object-fit: contain;
  border-radius: 9px;
  background-color: #ffffff;
  object-fit: contain;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  color: #ff8200;
  border: 2px solid #ff8200;
};

.div_info {
  margin: auto 0;
  text-align: center;
}
.div_info span {
  margin-left: 10px;
}

@media screen and (max-width: 1140px){
  .toolbar {
    grid-template-rows: auto auto auto;
    grid-template-columns: 1fr;
    grid-row-gap: 15px;
  }
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
}
@media screen and (max-width: 320px){
}
</style>
